import { render } from "./HonorariesForm.vue?vue&type=template&id=36f94c33&scoped=true"
import script from "./HonorariesForm.vue?vue&type=script&lang=js"
export * from "./HonorariesForm.vue?vue&type=script&lang=js"

import "./HonorariesForm.vue?vue&type=style&index=0&id=36f94c33&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f94c33"]])

export default __exports__